import styled from 'styled-components';

import { BackgroundElement } from '@/core/interfaces/common';

import mediaQueries from '@/utils/mediaQueries';
import { colors } from '@/utils/constants';

const {
  desktop,
  tablet,
} = mediaQueries;

export const Wrapper = styled.div<{ $isFullScreen?: boolean }>`
  width: 100%;
  max-width: ${props => (props.$isFullScreen ? '100%' : '1064px;')};
  margin-top: 48px;
  border-radius: 4px;
  padding: 0 24px 35px;
  background-color: ${colors.white};
  color: ${colors.black};

  @media ${tablet} {
    margin-top: 104px;
    padding: 0 48px 35px;
  }

  @media ${desktop} {
    padding: 0 108px 35px;
  }
`;

export const ThankYouHeadline = styled.h3`
  font-weight: 500;
  font-size: 24px;
  line-height: 36px;
  text-align: center;
`;

export const ShareIconsWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const WantMoreText = styled.p`
  padding: 40px 0 20px;
  color: rgb(24 24 24 / 60%);
  font-size: 14px;
  line-height: 18px;
  text-align: center;
`;

export const DonateLinkWrapper = styled.div`
  margin: 20px 0;
`;

export const DonateLink = styled.a<BackgroundElement>`
  display: block;
  width: 295px;
  max-width: 100%;
  height: 56px;
  margin: 40px auto 35px;
  border: 0;
  border-radius: 4px;
  background-color: ${props => (props.backgroundcolor)};
  color: ${props => (props.textcolor)};
  font-weight: 700;
  font-size: 14px;
  line-height: 56px;
  text-align: center;
  text-decoration: none;
  cursor: pointer;

  @media ${desktop} {
    margin-top: 48px;
  }
`;

export const CheckMarkWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 28px auto;
`;
